<div class="card" *ngIf="authorizated">
	<div class="card-header">
		<h1><span (click)="newTransfer.transformation = false"
				[ngClass]="!newTransfer.transformation?'selected':'unselected'" [appCheckPermission]="[2043]"
				[permissionType]="permissionType.ALL">Transferencia
				<span [appCheckPermission]="[2049]" [permissionType]="permissionType.ALL">/</span>
			</span>
			<span (click)="newTransfer.transformation = true"
				[ngClass]="newTransfer.transformation?'selected':'unselected'" [appCheckPermission]="[2049]"
				[permissionType]="permissionType.ALL">Transformación</span> de Producto
		</h1>
	</div>
	<div class="card-body">
		<div [appCheckPermission]="[2043]" [permissionType]="permissionType.ALL">
			<p class="text-muted" [appCheckPermission]="[2049]" [permissionType]="permissionType.ALL"> <i
					class="fa fa-circle-info"></i> Si deseas cambiar el tipo de acción (transferencia o
				transformación), haz click arriba en el título</p>
		</div>
		<div class="row">
			<div [ngClass]="newTransfer.transformation?'col-sm-3':'col-sm'">
				<p class="h5">Configuración</p>
				<div class="row">
					<div class="col-sm">
						<div class="form-group">
							<label for="from" class="form-label">Desde <span class="required">*</span></label>
							<div class="input-group input-group-sm" *ngIf="inputs['from']!=undefined">
								<app-input-autocomplete
									(getTitle)="$event.filterElement.title = $event.filterElement.name"
									[allBorderRadius]="true" [placeholder]="'Ingresa una bodega origen'"
									(inputMethod)="writeWarehouse($event.event.target.value, inputs['from'],  inputs['to'])"
									(changeStatus)="selectWarehouse($event.filterElement, inputs['from'],  inputs['to'] )"
									[inputs]="inputs['from']" [filterElements]="inputs['from']?.filterElements"
									[custom]="true">
									<ng-template #itemsTemplate let-filter>
										<div items>
											<div class="field">
												<span class="val-span">{{filter.name}}</span>
												<span class="field-span">
													<b>
														<i class="fa fa-key"></i>
													</b> {{filter.code}}
													<b style="margin-left: 1rem;">
														<i class="fa fa-location-dot"></i>
													</b> {{filter.address}}
													<i class="fa fa-question" style="opacity: 0.6;"
														*ngIf="!filter.address"></i>
												</span>
											</div>
										</div>
									</ng-template>
								</app-input-autocomplete>
							</div>
						</div>
					</div>
					<div class="col-sm" *ngIf="newTransfer.transformation">
						<div class="form-group d-flex align-items-end justify-content-end h-100">
						<label class="form-label d-flex align-items-center gap-2 mb-0">
							Receta:
							<i 
							class="fa clickeable active fs-3" 
							[ngClass]="prescribe ? 'fa-toggle-on text-success' : 'fa-toggle-off'"
							tooltip="Activa/Desactiva si es una receta"
							(click)="prescribe = !prescribe">
							</i>
						</label>
						</div>
					</div>
					<div class="col-sm" *ngIf="!newTransfer.transformation">
						<div class="form-group">
							<label for="to" class="form-label">Hacia <span class="required">*</span></label>
							<div class="input-group input-group-sm" *ngIf="inputs['to']!=undefined">
								<app-input-autocomplete
									(getTitle)="$event.filterElement.title = $event.filterElement.name"
									[allBorderRadius]="true" [placeholder]="'Ingresa una bodega destino'"
									(inputMethod)="writeWarehouse($event.event.target.value, inputs['to'],  inputs['from'])"
									(changeStatus)="selectWarehouse($event.filterElement, inputs['to'],  inputs['from'])"
									[inputs]="inputs['to']" [filterElements]="inputs['to']?.filterElements"
									[custom]="true">
									<ng-template #itemsTemplate let-filter>
										<div items>
											<div class="field">
												<span class="val-span">{{filter.name}}</span>
												<span class="field-span">
													<b>
														<i class="fa fa-key"></i>
													</b> {{filter.code}}
													<b style="margin-left: 1rem;">
														<i class="fa fa-location-dot"></i>
													</b> {{filter.address}}
													<i class="fa fa-question" style="opacity: 0.6;"
														*ngIf="!filter.address"></i>
												</span>
											</div>
										</div>
									</ng-template>
								</app-input-autocomplete>
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="row">
					<div class="col-sm">
						<div class="form-group">
							<label for="description" class="form-label">Descripción </label>
							<input type="text" name="description" placeholder="Ingresa una descripción" id="description"
								class="form-control">
						</div>
					</div>
				</div> -->
				<div class="row">
					<div class="col-sm">
						<div class="form-group">
							<label for="issuedDate" class="form-label">Fecha de Proceso</label>
							<input type="date" [(ngModel)]="issuedDate" name="issuedDate" id="issuedDate"
								class="form-control">
							<!-- <p class="form-text" style="text-align: right;color: var(--bg-bs-servicios);">
								<span [ngClass]="newTransfer.instantProcess?'clicked':'no-clicked'"
									(click)="newTransfer.instantProcess = !newTransfer.instantProcess">
									<i
										[ngClass]="newTransfer.instantProcess?'fa-solid fa-circle-check':'fa-regular fa-circle'"></i>Proceso
									Instantáneo
								</span>
							</p> -->
						</div>
					</div>
					<div class="col-sm" *ngIf="!newTransfer.instantProcess">
						<div class="form-group">
							<label for="expectedDate" class="form-label">Fecha Esperada de Finalización</label>
							<input type="date" [(ngModel)]="expectedDate" [min]="issuedDate" name="expectedDate"
								id="expectedDate" class="form-control">
						</div>
					</div>
				</div>
				<div class="row" style="margin-bottom: 1em;" *ngIf="!newTransfer.transformation">
					<div class="col form-group">
						<label for="carrier" class="form-label">Transportista <span
								class="text-muted">(nit/cui)</span></label>
						<div class="input-group">
							<app-input-autocomplete [allBorderRadius]="true" [inputs]="carrier"
								[placeholder]="'Ingresa un nit o cui'" [filterElements]="carrier.filterElements"
								[typeElements]="'client'" [custom]="true" [ruleToDisabled]="searchingCarrier"
								(inputMethod)="writeClient()" (changeStatus)="selectCarrier($event.filterElement)">
								<ng-template #itemsTemplate let-filter>
									<div items>
										<div class="field">
											<span class="val-span">{{filter.name}}</span>
											<span class="field-span">
												<b>NIT</b> {{filter.nit}}
											</span>
										</div>
									</div>
								</ng-template>
							</app-input-autocomplete>
						</div>
					</div>
					<div class="col form-group">
						<label for="plate" class="form-label">Placa</label>
						<input type="text" placeholder="Ingrese una placa" class="form-control" name="plate" id="plate"
							[(ngModel)]="newTransfer.plate">
					</div>
				</div>
			</div>
			<div class="col-sm" style="position: relative;" *ngIf="!newTransfer.transformation">
				<div class="blur-div" *ngIf="!inputs['from']?.verified || !inputs['to']?.verified">
					<span class="h5"><i class="fa fa-circle-info"></i>Selecciona las bodegas primero</span>
				</div>
				<p class="h5">Agregar productos</p>
				<div class="form-group">
					<div class="input-group" *ngIf="inputs['product']">
						<label for="to" class="input-group-text"><i class="fa fa-box"></i></label>
						<app-input-autocomplete
							(getTitle)="$event.filterElement.title = $event.filterElement.code + ' - ' +$event.filterElement.name"
							[allBorderRadius]="false" [placeholder]="'Ingresa un producto'"
							(inputMethod)="writeProduct($event.event.target.value, inputs['product'], false)"
							(changeStatus)="selectProduct($event.filterElement, inputs['product'], false)"
							[inputs]="inputs['product']" [custom]="true"
							[filterElements]="inputs['product']?.filterElements">
							<ng-template #itemsTemplate let-filter>
								<div class="field">
									<span class="val-span">{{filter.name}}</span>
									<span class="field-span">
										<b>
											<i class="fa fa-barcode"></i>
										</b>
										{{filter.barCode}}
										<i class="fa fa-question" style="opacity: 0.8;" *ngIf="!filter.barCode"></i>
										<b style="margin-left: 1rem;">
											<i class="fa fa-key"></i>
										</b>
										{{filter.code}}
										<i class="fa fa-question" style="opacity: 0.8;" *ngIf="!filter.code"></i>
									</span>
								</div>
							</ng-template></app-input-autocomplete>
					</div>
				</div>
				<div class="table-responsive" *ngIf="listProducts.length > 0">
					<table class="table table-striped">
						<thead>
							<tr>
								<th>Producto</th>
								<!-- <th class="ta">Existencia</th> -->
								<th class="ta">Cantidad</th>
								<th class="ta">Opciones</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let product of listProducts; let i = index">
								<td style="font-size: 0.8rem;">{{product.name}}</td>
								<!-- <td class="ta" style="font-size: 0.8rem;">{{product.existence}}</td> -->
								<td style="max-width: 80px;">
									<div class="form-group form-group-sm" style="position: relative;">
										<input type="number" style="font-size: 0.8rem;padding: 0;text-align: center;"
											[(ngModel)]="product.quantity" name="quantity" id="quantity"
											class="form-control">
										<p class="form-text" style="font-size: 0.7rem;"
											*ngIf="!prescribe && product.existence < product.quantity"><i
												class="fa fa-warning text-danger"></i>No puede ser mayor que la
											existencia</p>
									</div>
								</td>
								<td class="ta"><i (click)="deleteProductFromList(i, false)"
										class="text-danger clickeable fa fa-trash"></i></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="col-sm-9" style="position: relative;" *ngIf="newTransfer.transformation">
				<div class="blur-div" *ngIf="!inputs['from'].verified">
					<span class="h5"><i class="fa fa-circle-info"></i>Selecciona la bodega</span>
				</div>
				<p class="h5">Agregar productos</p>
				<div class="row">
					<div class="form-group">
						<label for="toTransfer" class="form-label">Productos a transformar</label>
						<div class="input-group input-group-sm">
							<label for="to" class="input-group-text"><i class="fa fa-box"></i></label>
							<app-input-autocomplete
								(getTitle)="$event.filterElement.title = $event.filterElement.code + ' - ' +$event.filterElement.name"
								[allBorderRadius]="false" [placeholder]="'Ingresa un producto a transformar'"
								(inputMethod)="writeProduct($event.event.target.value, inputs['toTransfer'], false)"
								(changeStatus)="selectProduct($event.filterElement, inputs['toTransfer'], false)"
								[inputs]="inputs['toTransfer']" [filterElements]="inputs['toTransfer']?.filterElements"
								[custom]="true">
								<ng-template #itemsTemplate let-filter>
									<div class="field">
										<span class="val-span">{{filter.name}}</span>
										<span class="field-span">
											<b>
												<i class="fa fa-barcode"></i>
											</b>
											{{filter.barCode}}
											<i class="fa fa-question" style="opacity: 0.8;" *ngIf="!filter.barCode"></i>
											<b style="margin-left: 1rem;">
												<i class="fa fa-key"></i>
											</b>
											{{filter.code}}
											<i class="fa fa-question" style="opacity: 0.8;" *ngIf="!filter.code"></i>
										</span>
									</div>
								</ng-template>
							</app-input-autocomplete>
						</div>
					</div>
					<div class="table-responsive" *ngIf="listProducts.length > 0 ">
						<table class="table table-striped">
							<thead>
								<tr>
									<th>Producto</th>
									<!-- <th class="td-center">Existencia</th> -->
									<th class="td-center">Cantidad</th>
									<th class="ta" *ngIf="prescribe">costo (Total)</th>
									<th class="td-center">Opciones</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let product of listProducts; let i = index">
									<td style="font-size: 0.8rem;">{{product.name}}</td>
									<!-- <td class="ta" style="font-size: 0.8rem;">{{product.existence}}</td> -->
									<td style="max-width: 80px;">
										<div class="form-group form-group-sm" style="position: relative;">
											<input type="number"
												style="font-size: 0.8rem;padding: 0;text-align: center;"
												[(ngModel)]="product.quantity" name="quantity" id="quantity"
												class="form-control">
											<p class="form-text" style="font-size: 0.7rem;"
												*ngIf="!prescribe && product.existence < product.quantity"><i
													class="fa fa-warning text-danger"></i>No puede ser mayor que la
												existencia</p>
										</div>
									</td>
									<td class="ta" *ngIf="prescribe">
										{{ (product.cost*product.quantity) | currency:'Q':'symbol':'1.2-2' }}
									</td>
									<td class="ta"><i (click)="deleteProductFromList(i, false)"
											class="text-danger clickeable fa fa-trash"></i></td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<td colspan="2" class="font-bold">TOTAL</td>
									<td class="ta font-bold">{{ totalcost | currency:'Q' }}</td>
									<td></td>
								</tr>
							</tfoot>
						</table>
					</div>
					<div class="form-group" style="margin-top: 1em;">
						<label for="results" class="form-label">Productos resultantes</label>
						<div class="input-group input-group-sm">
							<label for="to" class="input-group-text"><i class="fa fa-box"></i></label>
							<app-input-autocomplete
								(getTitle)="$event.filterElement.title = $event.filterElement.code + ' - ' +$event.filterElement.name"
								[allBorderRadius]="false" [placeholder]="'Ingresa un producto resultante'"
								(inputMethod)="writeProduct($event.event.target.value, inputs['result'],true)"
								(changeStatus)="selectProduct($event.filterElement, inputs['result'],true)"
								[inputs]="inputs['result']" [custom]="true"
								[filterElements]="inputs['result']?.filterElements">
								<ng-template #itemsTemplate let-filter>
									<div class="field">
										<span class="val-span">{{filter.name}}</span>
										<span class="field-span">
											<b>
												<i class="fa fa-barcode"></i>
											</b>
											{{filter.barCode}}
											<i class="fa fa-question" style="opacity: 0.8;" *ngIf="!filter.barCode"></i>
											<b style="margin-left: 1rem;">
												<i class="fa fa-key"></i>
											</b>
											{{filter.code}}
											<i class="fa fa-question" style="opacity: 0.8;" *ngIf="!filter.code"></i>
										</span>
									</div>
								</ng-template></app-input-autocomplete>
						</div>
					</div>
					<div class="table-responsive" *ngIf="toProducts.length > 0">
						<table class="table table-striped">
							<thead>
								<tr>
									<th>Producto</th>
									<th class="td-center">Cantidad</th>
									<th class="td-center">%</th>
									<th class="td-center">Opciones</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let product of toProducts; let i = index">
									<td style="font-size: 0.8rem;">{{product.name}}</td>
									<td style="max-width: 80px;">
										<div class="form-group form-group-sm" style="position: relative;">
											<input type="number"
												style="font-size: 0.8rem;padding: 0;text-align: center;"
												[(ngModel)]="product.quantity" name="quantity" id="quantity"
												class="form-control">
										</div>
									</td>
									<td style="max-width: 80px;">
										<div class="form-group form-group-sm" style="position: relative;">
											<input type="number"
												style="font-size: 0.8rem;padding: 0;text-align: center;"
												[(ngModel)]="product.costPercentage" name="cost" id="cost"
												class="form-control">
										</div>
									</td>
									<td class="ta"><i (click)="deleteProductFromList(i, true)"
											class="text-danger clickeable fa fa-trash"></i></td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<td colspan="2">
										<span *ngIf="!verifiedPercentage()"><i class="text-warning fa fa-warning"></i>
											Los porcentajes tienen que sumar 100</span>
									</td>
									<td>
										<span [ngClass]="newTransfer.addCost?'clicked':'no-clicked'"
											(click)="newTransfer.addCost = !newTransfer.addCost">
											<i
												[ngClass]="newTransfer.addCost?'fa-solid fa-circle-check':'fa-regular fa-circle'"></i>Adicionar
											Costo
										</span>
									</td>
									<td>
										<span [ngClass]="newTransfer.isVirtual?'clicked':'no-clicked'"
											(click)="newTransfer.isVirtual = !newTransfer.isVirtual">
											<i
												[ngClass]="newTransfer.isVirtual?'fa-solid fa-circle-check':'fa-regular fa-circle'"></i>Producto
											Virtual
										</span>
									</td>
								</tr>
							</tfoot>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="card-footer" style="display: flex;justify-content: center;align-items: center;">
		<button class="btn btn-primary" (click)="transferProducts()"
			[disabled]="listProducts.length == 0 || (newTransfer.transformation && toProducts.length == 0) || loading">
			<i *ngIf="!loading" class="fa-solid fa-share-from-square"></i>
			<span *ngIf="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
			{{newTransfer.transformation?'TRANSFORMAR':'TRANSFERIR'}}
		</button>
	</div>
</div>
<div class="card" *ngIf="!authorizated">
	<div class="card-body">
		<p class="display-1 text-center text-info" style="padding: 4rem;">
			<i class="fa-solid fa-user-shield"></i> No cuentas los permisos necesarios. Contacta con el administrador.
		</p>
	</div>
</div>